import type { Role } from '@/entities/user';

import type { RemoteAuthUser } from './remoteAuthTypes';

const ECOMMERCE = 'ECOMMERCE';
const QCOMMERCE = 'QCOMMERCE';

/**
 * Maps gateway `(platform, role)` tuples to a single dashboard `Role`.
 *
 * Precedence when multiple tuples apply: most privileged / operational first —
 * super admin and finance roles before warehouse-only, then legacy `MANAGER`
 * string (no platform).
 */
export function resolveDashboardRole(api: RemoteAuthUser): Role {
  const roles = Array.isArray(api.roles) ? api.roles : [];
  if (hasTuple(roles, QCOMMERCE, 'SUPER_ADMIN') || hasTuple(roles, ECOMMERCE, 'SUPER_ADMIN')) {
    return 'admin';
  }
  if (hasTuple(roles, ECOMMERCE, 'FINANCE_ADMIN')) {
    return 'finance_admin';
  }
  if (hasTuple(roles, ECOMMERCE, 'ACCOUNTANT')) {
    return 'accountant';
  }
  if (hasTuple(roles, QCOMMERCE, 'WAREHOUSE_MANAGER')) {
    return 'warehouse_manager';
  }
  const codes = new Set(roles.map((r) => String(r.role).toUpperCase()));
  if (codes.has('MANAGER')) {
    return 'warehouse_manager';
  }
  return 'admin';
}

function hasTuple(
  roles: Array<{ platform: string; role: string }>,
  platform: string,
  role: string,
): boolean {
  const p = platform.toUpperCase();
  const r = role.toUpperCase();
  return roles.some(
    (entry) => String(entry.platform).toUpperCase() === p && String(entry.role).toUpperCase() === r,
  );
}
